module.exports = __webpack_public_path__ + "img/landing-invest-news.7cd339ba.svg";